import { useState, useEffect } from "react";
import { query, collection, getDocs, orderBy, limit } from "firebase/firestore";
import { db } from "../../../util/firebase";
import BarLoader from "react-spinners/BarLoader";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";

function AdminWalletTransactionsPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const navigate = useNavigate();

  const fetchTransactions = async () => {
    try {
      setIsLoading(true);
      // Fetch latest 250 wallet transactions
      const q = query(
        collection(db, "wallet_transactions"),
        orderBy("timestamp", "desc"),
        limit(250)
      );
      const docs = await getDocs(q);
      const data = docs.docs.map((d) => ({ id: d.id, ...d.data() }));
      setTransactions(data);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching wallet transactions");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="walletTransactionsPage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        WALLET TRANSACTIONS
      </h1>

      <div className="adminPageSection">
        {transactions.length === 0 ? (
          <p style={{ color: "#9aa3bf", textAlign: "center" }}>
            No transactions recorded yet.
          </p>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {transactions.map((t) => (
              <div
                key={t.id}
                style={{ background: "#081026", padding: 12, borderRadius: 8 }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <strong>{t.userUid || "-"}</strong>
                    <div style={{ color: "#9aa3bf" }}>
                      {t.reason || t.type || "transaction"}
                    </div>
                    {t.tournamentUid ? (
                      <div style={{ color: "#9aa3bf" }}>
                        Tournament: {t.tournamentUid}
                      </div>
                    ) : null}
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontWeight: 700 }}>
                      {t.change >= 0 ? `+${t.change}` : t.change} {t.currency}
                    </div>
                    <div style={{ color: "#9aa3bf" }}>
                      {new Date(
                        t.timestamp?.toDate ? t.timestamp.toDate() : t.timestamp
                      ).toLocaleString()}
                    </div>
                  </div>
                </div>
                {typeof t.previousBalance !== "undefined" &&
                typeof t.newBalance !== "undefined" ? (
                  <div style={{ marginTop: 8, color: "#9aa3bf" }}>
                    {t.previousBalance} → {t.newBalance}
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminWalletTransactionsPage;
